import { Typography } from '@mui/joy';
import { useTheme } from '@mui/joy/styles';
import { Trans } from 'react-i18next';

import { formatDate } from 'core/utils';

interface IProps {
  updatedAt: string;
}

export const UpdatedAtSubtitle = ({ updatedAt }: IProps) => {
  const theme = useTheme();

  return (
    <Typography sx={{ color: theme.palette.text.secondary }}>
      <Trans
        i18nKey="subtitleLastUpdate"
        values={{ value: formatDate(updatedAt) }}
        components={{
          labelWrapper: <Typography fontWeight={500} />,
          valueWrapper: <Typography sx={{ color: theme.palette.neutral[800], fontWeight: 600 }} />,
        }}
      />
    </Typography>
  );
};
